// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__mDzvK","col":"CardReaderDesc_col__rxjKp","label":"CardReaderDesc_label__zFWwW"};